module.exports = __webpack_public_path__ + "img/bitab-2.83d5148b.png";